import React from 'react';
import { Upload } from 'antd';
import { useFormContext } from 'react-hook-form';

const { Dragger } = Upload;

export default function UploadCSVToSimulate() {
  const { watch, setValue, trigger } = useFormContext();

  const setFile = f => {
    setValue('file', f);
    trigger('templateId');
  };

  const file = watch('file');

  return (
    <Dragger
      accept="text/csv"
      beforeUpload={uploadedFile => {
        setFile(uploadedFile);
        return false;
      }}
      fileList={file ? [file] : []}
      multiple={false}
      onRemove={() => setFile(null)}
    >
      <p className="ant-upload-text">Upload your CSV file here</p>
      <p className="ant-upload-hint">
        The CSV will return additional columns indicating if the email would be
        throttled or not
      </p>
    </Dragger>
  );
}
